import {autorun, computed, observable, makeObservable} from 'mobx';

import autobind from 'common/decorators/autobind.js';
import http from 'http.js';
import {snakeToCamelObjectKeys} from 'utils/case_converter.js';
import Store from 'core/stores/Store.js';

export default class AutocompleteStore extends Store {
    constructor(initUrl, parentStore) {
        super(initUrl);

        makeObservable(this, {
            inputError: observable,
            value: observable,
            results: observable,
            selected: observable,
            showResults: observable,
            highlightedResult: observable,
            url: observable,

            suggestions: computed,
            highlightedResultIndex: computed,
            searchParams: computed,
        });

        this.url = initUrl;
        this.parentStore = parentStore;
        autorun(() => this.fetchAutocomplete(), {delay: 250});
    }

    inputError = {
        showError: false,
        errorWasShown: false,
    };
    value = '';
    results = [];
    selected = {};
    showResults = false;
    highlightedResult = 0;
    url = '';

    get suggestions() {
        if (!this.value) {
            return [];
        }

        return this.transformSuggestions(this.results);
    }

    get highlightedResultIndex() {
        if (this.highlightedResult < 0) {
            return this.results.length - 1;
        }
        return this.highlightedResult % this.results.length;
    }

    get searchParams() {
        if (!this.value) {
            return {};
        }
        return this.transformSearchParams({q: this.value});
    }

    @autobind
    async fetchAutocomplete() {
        if (!this.value) {
            return;
        }

        let response = await http.get({
            url: this.url,
            data: this.searchParams,
        });

        if (response.hasOwnProperty('results')) {
            response = response.results;
        }

        const storeData = {
            results: Object.values(snakeToCamelObjectKeys(response)),
        };
        this.updateStore(this.transformResponse(storeData));
    }

    transformResponse(storeData) {
        return storeData;
    }

    transformSearchParams(params) {
        return params;
    }

    transformSuggestions(suggestions) {
        return suggestions;
    }
}
